<template>
  <v-layout class="fee-type-generator" column>
    <v-layout>
      <FeeTypeSelector
        class="fee-type-dropdown"
        @input="handleInput"
        :value="computedChargeType"
      />
      <PriceInput
        v-show="chargeTypeIndex === 2"
        :rules="priceRules"
        class="price-input"
        data-qa="price-input"
        :currencySymbol="currencySymbol || ''"
        :value="parseFloat(price)"
        @input="val => $emit('price-input', val)"/>
    </v-layout>

    <v-layout
      class="checkboxes-container"
      column
      :class="{'display-checkboxes': chargeTypeIndex === 2}"
    >

      <VcitaCheckbox
        v-if="isAppointment"
        v-show="chargeTypeIndex === 2"
        data-qa="add-payment-link-checkbox"
        :ripple="false"
        hide-details="auto"
        color="#54d28c"
        class="fee-checkbox"
        v-model="addPaymentLink"
        :label="$t('booking.info.add_payment_link')">
      </VcitaCheckbox>

      <VcitaCheckbox
        v-if="isEvent"
        v-show="chargeTypeIndex === 2"
        data-qa="online-payment-checkbox"
        :ripple="false"
        hide-details="auto"
        color="#54d28c"
        class="fee-checkbox"
        v-model="allowOnlinePayment"
        :label="$t('booking.info.allow_online_payment')">
      </VcitaCheckbox>

      <VcitaCheckbox
        v-if="isEvent"
        v-show="chargeTypeIndex === 2 && allowOnlinePayment"
        data-qa="force-pay-checkbox"
        :ripple="false"
        hide-details="auto"
        class="fee-checkbox"
        color="#54d28c"
        v-model="clientMustPayUpfront"
        :label="$t('booking.info.client_must_pay_upfront')">
      </VcitaCheckbox>
    </v-layout>


  </v-layout>
</template>

<script>
  import {VcitaCheckbox} from "@/modules/common/components"
  import {PriceInput} from "@/modules/payments/components"
  import FeeTypeSelector from "@/modules/payments/components/FeeTypeSelector/FeeTypeSelector.vue"
  export default {
    name: "FeeTypeGenerator",
    components: {
      PriceInput,
      VcitaCheckbox,
      FeeTypeSelector,
    },
    props: {
      charge_type: {
        type: String,
        required: true,
        validator(val) {
          return ['no_price', 'free', 'discuss', 'paid_non_secured', 'paid_force', 'paid'].indexOf(val) !== -1
        }
      },
      service_charge_type: {
        type: String,
        validator(val) {
          return ['no_price', 'free', 'discuss', 'paid_non_secured', 'paid_force', 'paid'].indexOf(val) !== -1
        }
      },
      price: {
        type: [Number, String],
        required: true,
      },
      currencySymbol: {
        type: String,
        required: true,
      },
      priceRules: {
        type: Array,
        default: () => []
      },
      entityType: {
        type: String
      }
    },
    watch: {
      charge_type: {
        handler(val) {
          this.allowOnlinePayment = false;
          this.clientMustPayUpfront = false;
          this.chargeTypeIndex = this.chargeTypeIndexMap[val];
          if(val === 'paid_force') {
            this.allowOnlinePayment = true
            this.clientMustPayUpfront = true
            this.addPaymentLink = true
          } else if (val == "paid_non_secured") {
              this.addPaymentLink = false
          } else if (val === 'paid') {
            this.allowOnlinePayment = true
            this.addPaymentLink = true
          }
        },
        immediate: true,
      },
      computedChargeType: {
        handler(val) {
          this.$emit('charge-type-input', val)
        },
        immediate: true,
      },
    },
    data() {
      return {
        chargeTypeIndex: 0,
        chargeTypeIndexMap: {
          'no_price': 0,
          'free': 0,
          'discuss': 1,
          'paid_non_secured': 2 ,
          'paid_force': 2,
          'paid': 2,
        },
        allowOnlinePayment: true,
        addPaymentLink: false,
        clientMustPayUpfront: false
      }
    },
    methods: {
      handleInput(val) {
        const chargeTypeIndex = this.chargeTypeIndexMap[val]
        this.chargeTypeIndex = chargeTypeIndex;
        if(chargeTypeIndex === 2) {
          this.allowOnlinePayment = true;
          this.clientMustPayUpfront = true;
        }
      }
    },
    computed: {
      computedChargeType() {
        const chargeTypeIndex = this.chargeTypeIndex
        let res = '';
        const FREE = 0;
        const PRICE_VARIES = 1;
        const PAID = 2;
        if(chargeTypeIndex === FREE) {
          res = 'free'
        } else if(chargeTypeIndex === PRICE_VARIES) {
          res = 'discuss'
        } else if(chargeTypeIndex === PAID) {
          if (this.isAppointment) {
            if (this.addPaymentLink) {
              if (this.service_charge_type == "paid_force" || this.charge_type === "paid_force") {
                res = "paid_force"
              } else {
                res = "paid"
              }
            } else {
              res = "paid_non_secured"
            }
          } else if(this.allowOnlinePayment && this.isEvent) {
            if(this.clientMustPayUpfront) {
              res = 'paid_force'
            } else {
              res = 'paid'
            }
          } else {
            res = 'paid_non_secured'
          }
        }
        return res;
      },
      brandBgColor() {
        return this.$store && this.$store.getters['brandModule/secondaryColor'];
      },
      isAppointment() {
        return this.entityType === "appointment"
      },
      isEvent() {
        return this.entityType === "event"
      }
    }

  };
</script>


<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";
  .fee-title {
    font-family: var(--primary-font-family);
    font-size: 12px;
    line-height: 1.17;
    letter-spacing: -0.3px;
    color: rgba(0, 0, 0, 0.62);
    margin-bottom: 4px;
  }
  .type-selector {
    margin-bottom: 16px;
  }
  .checkboxes-container {
    max-height: 0;
    transition: max-height 0.3s;
    &.display-checkboxes {
      max-height: 300px;
    }
  }
  .price-input {
    margin-bottom: 16px;
  }
  .fee-checkbox {
    font-family: var(--primary-font-family);
    font-size: 15px;
    color: rgba(0, 0, 0, 0.87);
    margin-top: 0;
    padding-top: 0;
    max-height: 300px;
    transition: max-height 0.3s;
    &.hide {
      max-height: 0;
    }
    &:not(:last-child) {
      margin-bottom: 16px;
    }
    ::v-deep {
      label {
        font-family: var(--primary-font-family);
        font-size: 15px;
        line-height: 1.6;
        color: rgba(0, 0, 0, 0.87);
      }
      .v-input--selection-controls__input {
        height: 1em;
        width: 1em;
      }
      i {
        font-size: 20px;
      }
    }


  }
 .fee-type-dropdown + .price-input {
    margin-inline-start: 16px;
  }
</style>
